<template>
  <div class="page_body">
    <HomeTop :topTitle="topTitle"></HomeTop>
    <div class="pdf_viewer_body">
      <div class="pdf_viewer_container" v-if="!isWeixin">
        <iframe
          class="pdf_viewer_iframe"
          :src="pdfViewerUrl"
          frameborder="0"
          @error="onPdfError"
        ></iframe>
      </div>
      <div class="pdf_viewer_weixin" v-else>
        <div class="pdf_viewer_tips">
          <div class="pdf_viewer_tips_title">正在打开PDF文档...</div>
          <div class="pdf_viewer_tips_desc">如果未自动打开，请点击下方按钮</div>
        </div>
        <div class="pdf_viewer_btn_box">
          <div class="pdf_viewer_btn" @click="openPDFInWeixin()">
            打开PDF文档
          </div>
          <div class="pdf_viewer_btn pdf_viewer_btn_download" @click="downloadPDF()">
            下载PDF文档
          </div>
        </div>
      </div>
      <div class="pdf_viewer_error" v-if="!pdfViewerUrl && !isWeixin">
        <div class="pdf_viewer_error_text">PDF文件加载失败，请稍后重试</div>
      </div>
    </div>
  </div>
</template>
<style src="../../assets/css/examManual/pdfViewer.css" scoped></style>

<script>
import HomeTop from "@/components/homeTop.vue";
import wx from "weixin-js-sdk";
import { Toast } from "mint-ui";

export default {
  name: "PdfViewer",
  components: {
    HomeTop,
  },
  data() {
    return {
      topTitle: "考试手册",
      pdfUrl: "",
      pdfViewerUrl: "",
      baseAPIUrl: this.$store.state.baseAPIUrl,
      isWeixin: false, // 是否在微信环境
      wxJSSDKConfig: {}, // 微信JSSDK配置
      realUrl: "",
    };
  },
  created: function () {
    // 检测是否在微信环境
    this.isWeixin = this.checkWeixin();
    
    // 获取路由参数
    let title = this.$route.params.title;
    let pdfUrl = this.$route.params.pdfUrl;
    
    if (title) {
      this.topTitle = title;
    }
    
    if (pdfUrl) {
      this.pdfUrl = pdfUrl;
      // 构建PDF查看URL
      if (pdfUrl.startsWith("/")) {
        this.pdfViewerUrl = this.baseAPIUrl + pdfUrl;
      } else if (pdfUrl.startsWith("http://") || pdfUrl.startsWith("https://")) {
        this.pdfViewerUrl = pdfUrl;
      } else {
        this.pdfViewerUrl = this.baseAPIUrl + "/" + pdfUrl;
      }
    }
    
    // 如果在微信环境，初始化微信JSSDK
    if (this.isWeixin) {
      this.realUrl = this.$store.state.baseUrl + this.$route.fullPath;
      this.initWeixinJSSDK();
    }
  },
  methods: {
    // 检测是否在微信环境
    checkWeixin: function () {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") !== -1;
    },
    // 初始化微信JSSDK
    initWeixinJSSDK: function () {
      let that = this;
      this.getWXJSSDKConfigFn().then((res) => {
        if (res) {
          wx.config({
            debug: false,
            appId: that.wxJSSDKConfig.appid,
            timestamp: that.wxJSSDKConfig.time,
            nonceStr: that.wxJSSDKConfig.password,
            signature: that.wxJSSDKConfig.signature,
            jsApiList: ["downloadFile", "openDocument"], // 需要使用的 JS 接口列表
          });
          wx.ready(function () {
            // 自动打开PDF
            that.openPDFInWeixin();
          });
          wx.error(function (res) {
            console.log("微信JSSDK配置失败:", res);
            if (
              res.errMsg == "config:invalid signature" &&
              res.realAuthUrl &&
              res.realAuthUrl[0] != "" &&
              res.realAuthUrl[0] != undefined
            ) {
              that.realUrl = res.realAuthUrl[0];
            }
          });
        }
      });
    },
    // 获取WXJSSDK配置
    getWXJSSDKConfigFn: function () {
      let that = this;
      let data = {
        url: this.realUrl,
      };
      let url = "/mobile/getjssdkconfig";
      return new Promise(function (resolve) {
        that.axios
          .post(url, data)
          .then((response) => {
            if (response.code == 0) {
              that.wxJSSDKConfig = response.signpackage;
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(function (error) {
            console.log("获取微信JSSDK配置失败:", error);
            resolve(false);
          });
      });
    },
    // 在微信中打开PDF
    openPDFInWeixin: function () {
      if (!this.pdfViewerUrl) {
        Toast({
          message: "PDF地址无效",
          duration: 3000,
        });
        return;
      }
      
      // 使用微信JSSDK打开文档
      if (typeof wx !== "undefined" && wx.openDocument) {
        // 需要先下载文件，然后打开
        wx.downloadFile({
          url: this.pdfViewerUrl,
          success: function (res) {
            if (res.statusCode === 200) {
              wx.openDocument({
                filePath: res.tempFilePath,
                success: function () {
                  console.log("打开文档成功");
                },
                fail: function (err) {
                  console.log("打开文档失败:", err);
                  Toast({
                    message: "打开文档失败，请尝试下载后查看",
                    duration: 3000,
                  });
                },
              });
            }
          },
          fail: function (err) {
            console.log("下载文件失败:", err);
            Toast({
              message: "下载文件失败，请稍后重试",
              duration: 3000,
            });
          },
        });
      } else {
        // 如果JSSDK未准备好，直接打开链接
        window.open(this.pdfViewerUrl, "_blank");
      }
    },
    // 下载PDF
    downloadPDF: function () {
      if (!this.pdfViewerUrl) {
        Toast({
          message: "PDF地址无效",
          duration: 3000,
        });
        return;
      }
      // 创建下载链接
      let link = document.createElement("a");
      link.href = this.pdfViewerUrl;
      link.download = this.topTitle + ".pdf";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // PDF加载错误处理
    onPdfError: function () {
      console.error("PDF加载失败");
    },
  },
};
</script>

